import { useStatsigClient } from '@statsig/react-bindings'
import { RELEASE_INFO_METADATA_IN_TRACKLIST } from 'constants/featureFlags'

const useReleaseInfoMetadataInTracklist = () => {
  const { checkGate, isLoading: isStatsigLoading } = useStatsigClient()

  return !isStatsigLoading && checkGate(RELEASE_INFO_METADATA_IN_TRACKLIST)
}

export default useReleaseInfoMetadataInTracklist
